import script from "./ChatReportItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatReportItem.vue?vue&type=script&setup=true&lang=js"

import "./ChatReportItem.vue?vue&type=style&index=0&id=01c0edbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c0edbc"]])

export default __exports__